// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1JsG7","itemTitle":"ClientEmergencyInfo_itemTitle__2SDpW","itemText":"ClientEmergencyInfo_itemText__3onJM"};